export default __webpack_public_path__ + "static/media/modal-bg-right.2d3bf181.png";